import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { zinc } from "@/ui/tokens";

/**
 * What the header shows while rows are ticked: how many, and a way to clear them. Beside the count at driver grain, in
 * its place at message grain. The actions over the ticked rows live in the header's action group, always there.
 */
export default React.memo(function DispatchSelectionBar({ count, onClear }: { count: number; onClear: () => void }) {
  return (
    <Box data-sb={TestIds.dispatch.selectionBar} sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: 1 }}>
      <Typography component="span" sx={{ color: zinc[200], fontSize: "0.8125rem", fontWeight: 600 }}>
        {count} selected
      </Typography>
      <ButtonBase
        aria-label="Clear selection"
        onClick={onClear}
        sx={{ borderRadius: "50%", p: 0.5, color: zinc[400], "&:hover": { color: "white" } }}
      >
        <ClearIcon sx={{ fontSize: 16 }} />
      </ButtonBase>
    </Box>
  );
});
